import React from "react";
import { Slide, useTheme } from "@mui/material";
import { Bot, User } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  AvatarContainer,
  Container,
  MessageBox,
  MessageContainer,
} from "@components/ChatAgent/components/ChatAgentMessageBox/style";
import {
  AgentOption,
  AgentOptionsRow,
} from "@components/ChatAgent/components/ChatAgentAgentSelector/style";
import { AgentType } from "@hooks/useChatAgent";

interface ChatAgentAgentSelectorProps {
  // null = nessuna scelta fatta, mostriamo le pillole;
  // valorizzato = mostriamo l'opzione utente con la scelta dell'agente.
  selectedType: AgentType | null;
  onSelect: (type: AgentType) => void;
  disabled?: boolean;
}

const ChatAgentAgentSelector: React.FC<ChatAgentAgentSelectorProps> = ({
  selectedType,
  onSelect,
  disabled,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("agent_chat");

  const selectedLabel = selectedType
    ? selectedType === "support"
      ? t("agentTypeSupport")
      : t("agentTypeAdmin")
    : null;

  return (
    <Slide direction="up" in mountOnEnter unmountOnExit>
      <div>
        <Container isAI={true} messageIndex={0} gap={"10px"}>
          <AvatarContainer isAI={true}>
            <Bot size={20} color="#000" />
          </AvatarContainer>
          <MessageContainer theme={theme} isAI={true}>
            <MessageBox isAI={true}>{t("agentSelectorPrompt")}</MessageBox>
          </MessageContainer>
        </Container>

        {selectedLabel ? (
          <Container
            isAI={false}
            messageIndex={1}
            gap={"10px"}
            sx={{ marginTop: "10px" }}
          >
            <AvatarContainer isAI={false}>
              <User size={20} color="#fff" />
            </AvatarContainer>
            <MessageContainer theme={theme} isAI={false}>
              <MessageBox isAI={false}>{selectedLabel}</MessageBox>
            </MessageContainer>
          </Container>
        ) : (
          <AgentOptionsRow>
            <AgentOption
              variant="outlined"
              disabled={disabled}
              onClick={() => onSelect("support")}
            >
              {t("agentTypeSupport")}
            </AgentOption>
            <AgentOption
              variant="outlined"
              disabled={disabled}
              onClick={() => onSelect("admin")}
            >
              {t("agentTypeAdmin")}
            </AgentOption>
          </AgentOptionsRow>
        )}
      </div>
    </Slide>
  );
};

export default ChatAgentAgentSelector;
